import React from 'react';
import { CheckIcon } from 'lucide-react';
export const Pricing = () => {
  return <section id="pricing" className="w-full py-16 md:py-24 px-6 md:px-12 bg-gray-50 dark:bg-gray-800" data-id="element-131">
      <div className="max-w-6xl mx-auto" data-id="element-132">
        <div className="text-center mb-12" data-id="element-133">
          <h2 className="text-2xl md:text-3xl font-bold mb-4" data-id="element-134">
            Simple, bed-based pricing.
          </h2>
          <p className="text-lg text-gray-600 dark:text-gray-300 max-w-2xl mx-auto" data-id="element-135">
            $0.50–$1 per bed / day (billed annually). Minimum 30 beds; cap at
            550 billed beds.
          </p>
        </div>
        <div className="mb-16" data-id="element-136">
          <h3 className="text-xl font-bold mb-6 text-center" data-id="element-137">
            Why hospitals choose this:
          </h3>
          <div className="flex justify-center" data-id="element-138">
            <ul className="space-y-4 ml-4 md:ml-4" data-id="element-139">
              <li className="flex items-center" data-id="element-140">
                <CheckIcon size={20} className="text-green-500 mr-3 flex-shrink-0" data-id="element-141" />
                <span className="text-gray-700 dark:text-gray-300" data-id="element-142">
                  Costs a fraction of potential CMS penalties.
                </span>
              </li>
              <li className="flex items-center" data-id="element-143">
                <CheckIcon size={20} className="text-green-500 mr-3 flex-shrink-0" data-id="element-144" />
                <span className="text-gray-700 dark:text-gray-300" data-id="element-145">
                  Predictable OPEX tied to your size.
                </span>
              </li>
              <li className="flex items-center" data-id="element-146">
                <CheckIcon size={20} className="text-green-500 mr-3 flex-shrink-0" data-id="element-147" />
                <span className="text-gray-700 dark:text-gray-300" data-id="element-148">
                  Includes our compliance guarantee.
                </span>
              </li>
            </ul>
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12" data-id="element-149">
          {/* Pricing Tier 1 */}
          <div className="bg-white dark:bg-gray-900 p-8 rounded-lg shadow-md border border-gray-200 dark:border-gray-700 transition-all hover:shadow-lg" data-id="element-150">
            <h3 className="text-xl font-bold mb-4 text-green-600 dark:text-green-400" data-id="element-151">
              30–300 beds
            </h3>
            <div className="mb-6" data-id="element-152">
              <p className="text-3xl font-bold" data-id="element-153">$1</p>
              <p className="text-gray-600 dark:text-gray-300" data-id="element-154">per bed / day</p>
            </div>
            <div className="border-t border-gray-200 dark:border-gray-700 pt-6" data-id="element-155">
              <p className="text-gray-600 dark:text-gray-300 mb-4" data-id="element-156">
                Perfect for small to medium-sized hospitals looking for
                affordable compliance.
              </p>
            </div>
          </div>
          {/* Pricing Tier 2 */}
          <div className="bg-white dark:bg-gray-900 p-8 rounded-lg shadow-md border border-gray-200 dark:border-gray-700 transition-all hover:shadow-lg" data-id="element-157">
            <h3 className="text-xl font-bold mb-4 text-green-600 dark:text-green-400" data-id="element-158">
              300–550+ beds
            </h3>
            <div className="mb-6" data-id="element-159">
              <p className="text-3xl font-bold" data-id="element-160">$0.50</p>
              <p className="text-gray-600 dark:text-gray-300" data-id="element-161">per bed / day</p>
            </div>
            <div className="border-t border-gray-200 dark:border-gray-700 pt-6" data-id="element-162">
              <p className="text-gray-600 dark:text-gray-300 mb-4" data-id="element-163">
                Optimized for larger hospitals with volume-based discounting.
              </p>
            </div>
          </div>
        </div>
        <div className="text-center" data-id="element-164">
          <a href="#contact" className="px-8 py-4 bg-green-600 hover:bg-green-700 text-white rounded-md text-lg font-medium transition-colors" data-id="element-165">
            Schedule Demo
          </a>
        </div>
      </div>
    </section>;
};